import React from 'react';
import { ReactSVG } from 'react-svg';
import styles from './Home.module.scss';
import logo from '../../icons/logo.svg';

export const Home: React.FC = () => {
  return (
    <section id="home" className="chapter">
      <div className="container">
        <div className="card_area">
          <div className="card_title">
            <h1 className={styles.card_title_img}>株式会社ミースチンとは</h1>
          </div>
          <div className={'card_content' + ' ' + styles.bg}>
            <p className={styles.text}>
              株式会社ミースチンは
              2023年3月に創業した、ゲーム開発・スマートフォンアプリ開発・Webアプリケーション開発を中心に行うシステム開発会社です。
              <br />
              <br />
              「本当に欲しかったものを作る」をモットーに、直観的でわかりやすく使いやすいアプリケーション開発をいたします。
              <br />
              <br />
              iOS / Android アプリ・Webシステム開発の受注制作もしております。
              <br />
              企画からのご提案もできますので、お気軽にお問合せください。
            </p>
          </div>
          <div className={styles.logo}>
            <ReactSVG src={logo} className={styles.test} />
          </div>
        </div>
      </div>
    </section>
  );
};
